const data = [
  {
    title: "Everyone's contribution",
    description:
      'We encourage self-belief, mutual respect and recognition. Everyone has a part to play in creating a fairer society, where people are truly valued and included.',
    image: 'graphicBurst5',
  },
  {
    title: 'Connection',
    description:
      'Our relationships make us. Passionate people, teamwork and collaboration are key to our success. We believe in the power of togetherness.',
    image: 'graphicBurst6',
  },
  {
    title: 'Resourcefulness',
    description:
      'We learn what works, share our expertise, and strive for efficiency. Our flexible and adaptable approach inspires communities to recognise and meet their own needs.',
    image: 'graphicBurst7',
  },
  {
    title: 'Ambition',
    description:
      'We turn energy into action. Our can-do attitude gets things done, while our confidence creates impact. We are hopeful, resilient and positive about driving change.',
    image: 'graphicBurst8',
  },
  {
    title: 'Creativity',
    description:
      'We are curious and inventive. We encourage fun and imagination in order to achieve true innovation.',
    image: 'graphicBurst9',
  },
];

export default data;
